import React from "react";

export default function IconCupon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-4 h-4"
        fill="none"
        viewBox="0 0 23 20"
        stroke="currentColor"
        strokeWidth="2"
        style={{ color: "#a0a0a0", marginRight: "24px", marginLeft: "12px" }}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15 9a2 2 0 10-4 0v5a2 2 0 01-2 2h6m-6-4h4m8 0a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </>
  );
}
